import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { CanDeactivate } from '@angular/router';
import { Subject } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { AlertComponent } from 'src/app/components/alert/alert.component';
import { TranslateService } from '@ngx-translate/core';


export interface ComponentCanDeactivate {
    canDeactivate: () => boolean | Observable<boolean>;
}
  
@Injectable({ providedIn: 'root' })
export class DeactivationGuard implements CanDeactivate<ComponentCanDeactivate> {
    ok = false;
    
    constructor(private modalController: ModalController, private translateService: TranslateService,) {
    }

    canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> | Promise<boolean> {
        return component.canDeactivate() ?
          true : this.openConfirmDialog(component);
    }
    async openConfirmDialog(component) {
        const alert = await this.modalController.create({
            component: AlertComponent,
            cssClass:"my-popover-alert",
            componentProps: {
              title: this.translateService.instant('WARNING').toUpperCase(),
              message: component['exitMessage']?component['exitMessage']:this.translateService.instant("DEACTIVATE_GENERAL"),
              outlineButtonConfirm: true,
              buttonCancel: this.translateService.instant('NO'),
              buttonConfirm: this.translateService.instant('YES')
            }
          });
          await alert.present();
         return  alert.onWillDismiss().then(async (result) => {
            return result && result["data"] && result["data"]["confirm"];
        })
    }
}   